import ReactGA from 'react-ga';
import { config } from './config';

if (config.GOOGLE_TRACK_ID) {
  ReactGA.initialize(config.GOOGLE_TRACK_ID);
  ReactGA.pageview(window.location.pathname + window.location.search);
}
